module.exports = __webpack_public_path__ + "img/b2c.32c97c0d.png";